(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.documentElement.classList.add('orr-ring-sort-ready');
  document.addEventListener('change', (event) => {
    if (event.target.matches('results-list[data-manual-pagination][data-ring-collection] .orr-category-sort select')) {
      event.target.form.requestSubmit();
    }
  });
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-bracelet-chapters"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orr-story-stories')) {
  customElements.define('orr-story-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-gallery]').forEach(gallery => {
        const track = gallery.querySelector('[data-track]');
        const slides = [...track.children];
        const prev = gallery.querySelector('[data-prev]');
        const next = gallery.querySelector('[data-next]');
        const counter = gallery.querySelector('[data-index]');
        const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        const update = () => { const i = index(); counter.textContent = i + 1; prev.disabled = i === 0; next.disabled = i === slides.length - 1; };
        const move = step => { const i = Math.max(0, Math.min(slides.length - 1, index() + step)); track.scrollTo({left: i * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'}); };
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', update, {passive:true, signal});
        track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } }, {signal});
        update();
      });
      this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting && !reduced.matches && !video.dataset.userPaused) video.play().catch(() => {});
        else video.pause();
      }), {threshold:.2});
      this.querySelectorAll('.orr-story-film').forEach(film => {
        const video = film.querySelector('video');
        const button = film.querySelector('[data-play]');
        if (!video || !button) return;
        const sync = () => { button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel); button.querySelector('[data-play-icon]').textContent = video.paused ? '▶' : 'Ⅱ'; };
        button.addEventListener('click', () => { if (video.paused) { delete video.dataset.userPaused; video.play().catch(() => {}); } else { video.dataset.userPaused = 'true'; video.pause(); } }, {signal});
        video.addEventListener('play', sync, {signal}); video.addEventListener('pause', sync, {signal});
        this.videoObserver.observe(video); sync();
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.videoObserver?.disconnect(); delete this.dataset.ready; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-bridal-journey"]) return;
  try {
    
document.addEventListener('click', event => {
  if (!window.matchMedia('(max-width:749px)').matches) return;
  const link = event.target.closest('.orr-journey__nav a[href^="#"]');
  if (!link) return;
  const chapter = document.getElementById(link.hash.slice(1));
  const details = chapter?.querySelector('.orr-journey__mobile-chapter');
  if (details) details.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-category-chapters"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orr-edit-stories')) {
  customElements.define('orr-edit-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-gallery]').forEach(gallery => {
        const track = gallery.querySelector('[data-track]');
        const slides = [...track.children];
        const prev = gallery.querySelector('[data-prev]');
        const next = gallery.querySelector('[data-next]');
        const counter = gallery.querySelector('[data-index]');
        if (!prev || !next || !counter) return;
        const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        const update = () => { const i = index(); counter.textContent = i + 1; prev.disabled = i === 0; next.disabled = i === slides.length - 1; };
        const move = step => { const i = Math.max(0, Math.min(slides.length - 1, index() + step)); track.scrollTo({left: i * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'}); };
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', update, {passive:true, signal});
        track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } }, {signal});
        update();
      });
      this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting && !reduced.matches && !video.dataset.userPaused) video.play().catch(() => {});
        else video.pause();
      }), {threshold:.2});
      this.querySelectorAll('.orr-edit-film').forEach(film => {
        const video = film.querySelector('video');
        const button = film.querySelector('[data-play]');
        if (!video || !button) return;
        const sync = () => { button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel); button.querySelector('[data-play-icon]').textContent = video.paused ? '▶' : 'Ⅱ'; };
        button.addEventListener('click', () => { if (video.paused) { delete video.dataset.userPaused; video.play().catch(() => {}); } else { video.dataset.userPaused = 'true'; video.pause(); } }, {signal});
        video.addEventListener('play', sync, {signal}); video.addEventListener('pause', sync, {signal});
        this.videoObserver.observe(video); sync();
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.videoObserver?.disconnect(); delete this.dataset.ready; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-cocktail-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cocktail-stories')) {
  customElements.define('cocktail-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-gallery]').forEach(gallery => {
        const track = gallery.querySelector('[data-track]');
        const slides = [...track.children];
        const prev = gallery.querySelector('[data-prev]');
        const next = gallery.querySelector('[data-next]');
        const counter = gallery.querySelector('[data-index]');
        const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        const update = () => { const i = index(); counter.textContent = i + 1; prev.disabled = i === 0; next.disabled = i === slides.length - 1; };
        const move = step => { const i = Math.max(0, Math.min(slides.length - 1, index() + step)); track.scrollTo({left: i * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'}); };
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', update, {passive:true, signal});
        track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } }, {signal});
        update();
      });
      const audio = this.querySelector('[data-audio]');
      const sound = this.querySelector('[data-sound]');
      const label = this.querySelector('[data-sound-label]');
      const volume = this.querySelector('[data-volume]');
      audio.volume = Number(volume.value);
      const syncSound = () => { sound.setAttribute('aria-pressed', String(!audio.paused)); label.textContent = audio.paused ? sound.dataset.start : sound.dataset.stop; };
      sound.addEventListener('click', async () => { if (audio.paused) { try { await audio.play(); } catch { this.querySelector('[data-audio-status]').textContent = sound.dataset.start; } } else audio.pause(); }, {signal});
      audio.addEventListener('play', syncSound, {signal});
      audio.addEventListener('pause', syncSound, {signal});
      audio.play().then(syncSound).catch(syncSound);
      volume.addEventListener('input', () => { audio.volume = Number(volume.value); }, {signal});
      document.addEventListener('visibilitychange', () => { if (document.hidden) audio.pause(); }, {signal});
      this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting && !reduced.matches && !video.dataset.userPaused) video.play().catch(() => {});
        else video.pause();
      }), {threshold:.2});
      this.querySelectorAll('.cocktail-film').forEach(film => {
        const video = film.querySelector('video');
        const button = film.querySelector('[data-play]');
        if (!video || !button) return;
        const sync = () => { button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel); button.querySelector('[data-play-icon]').textContent = video.paused ? '▶' : 'Ⅱ'; };
        button.addEventListener('click', () => { if (video.paused) { delete video.dataset.userPaused; video.play().catch(() => {}); } else { video.dataset.userPaused = 'true'; video.pause(); } }, {signal});
        video.addEventListener('play', sync, {signal}); video.addEventListener('pause', sync, {signal});
        this.videoObserver.observe(video); sync();
      });
    }
    disconnectedCallback() { this.querySelector('[data-audio]')?.pause(); this.abort?.abort(); this.videoObserver?.disconnect(); delete this.dataset.ready; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-cocktail-teal-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cocktail-teal-stories')) {
  customElements.define('cocktail-teal-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.abort = new AbortController();
      const signal = this.abort.signal;

      const allView = this.querySelector('[data-all-view]');
      const allGrid = this.querySelector('[data-all-grid]');
      const allCount = this.querySelector('[data-all-count]');
      const allFilters = [...this.querySelectorAll('[data-all-filter]')];
      const uniquePieces = new Map();
      this.querySelectorAll('.cocktail-teal-chapter').forEach((chapter, category) => {
        chapter.querySelectorAll('[data-slide]').forEach(card => {
          const link = card.querySelector('.cocktail-teal-piece-info h3 a');
          if (!link) return;
          const url = new URL(link.href, location.href);
          const key = url.pathname + (url.searchParams.has('variant') ? '?variant=' + url.searchParams.get('variant') : '');
          const existing = uniquePieces.get(key);
          if (existing) { existing.categories.add(String(category)); return; }
          const clone = card.cloneNode(true);
          clone.removeAttribute('data-slide');
          clone.removeAttribute('id');
          clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          clone.querySelectorAll('img').forEach(img => { img.sizes = '(min-width: 900px) 23vw, 46vw'; });
          uniquePieces.set(key, {card: clone, categories: new Set([String(category)])});
          allGrid.appendChild(clone);
        });
      });
      const filterPieces = category => {
        let count = 0;
        uniquePieces.forEach(piece => {
          piece.card.hidden = category !== 'all' && !piece.categories.has(category);
          if (!piece.card.hidden) count++;
        });
        allFilters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.allFilter === category)));
        allCount.textContent = count + (count === 1 ? ' piece' : ' pieces');
      };
      allFilters.forEach(button => button.addEventListener('click', () => filterPieces(button.dataset.allFilter), {signal}));
      this.querySelector('[data-all-invite]').hidden = false;
      const syncOverview = (focus = false) => {
        const open = location.hash === '#all-cocktail';
        if (!open && !this.hasAttribute('data-all-open')) return;
        this.toggleAttribute('data-all-open', open);
        allView.hidden = !open;
        if (open) {
          filterPieces('all');
        }
        if (focus) {
          window.scrollTo({top: 0, behavior: 'instant'});
          if (open) this.querySelector('#cocktail-all-title').focus({preventScroll: true});
        }
      };
      window.addEventListener('hashchange', () => syncOverview(true), {signal});
      syncOverview();

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-gallery]').forEach(gallery => {
        const track = gallery.querySelector('[data-track]');
        const slides = [...track.children];
        const prev = gallery.querySelector('[data-prev]');
        const next = gallery.querySelector('[data-next]');
        const counter = gallery.querySelector('[data-index]');
        const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        const update = () => { const i = index(); counter.textContent = i + 1; prev.disabled = i === 0; next.disabled = i === slides.length - 1; };
        const move = step => { const i = Math.max(0, Math.min(slides.length - 1, index() + step)); track.scrollTo({left: i * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'}); };
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', update, {passive:true, signal});
        track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } }, {signal});
        update();
      });
      const audio = this.querySelector('[data-audio]');
      const sounds = [...this.querySelectorAll('[data-sound]')];
      const volumes = [...this.querySelectorAll('[data-volume]')];
      audio.volume = Number(volumes[0].value);
      const syncSound = () => sounds.forEach(sound => {
        sound.setAttribute('aria-pressed', String(!audio.paused));
        sound.querySelector('[data-sound-label]').textContent = audio.paused ? sound.dataset.start : sound.dataset.stop;
      });
      let autoStartPending = true;
      const startMusic = () => audio.play().then(() => { autoStartPending = false; syncSound(); }).catch(syncSound);
      const startOnInteraction = event => {
        if (!autoStartPending || !event.isTrusted || document.hidden || event.target.closest('[data-sound], [data-volume]')) return;
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        startMusic();
      };
      document.addEventListener('click', startOnInteraction, {signal});
      document.addEventListener('keydown', startOnInteraction, {signal});
      sounds.forEach(sound => sound.addEventListener('click', async () => {
        autoStartPending = false;
        if (audio.paused) {
          try { await audio.play(); } catch { sound.parentElement.querySelector('[data-audio-status]').textContent = sound.dataset.start; }
        } else audio.pause();
      }, {signal}));
      audio.addEventListener('play', syncSound, {signal});
      audio.addEventListener('pause', syncSound, {signal});
      volumes.forEach(volume => volume.addEventListener('input', () => {
        audio.volume = Number(volume.value);
        volumes.forEach(control => { control.value = volume.value; });
      }, {signal}));
      startMusic();
      const videos = [...this.querySelectorAll('.cocktail-teal-film video')];
      const visible = new Set();
      const pending = new Set();
      const play = (video, manual = false) => {
        if (!video.paused || pending.has(video) || document.hidden) return;
        if (!manual && (video.dataset.userPaused || !visible.has(video))) return;
        video.muted = true;
        pending.add(video);
        video.play().catch(() => {}).finally(() => pending.delete(video));
      };
      const resume = () => videos.forEach(video => {
        if (document.hidden || !visible.has(video) || video.dataset.userPaused) {
          video.autoplay = false;
          video.pause();
        } else {
          video.autoplay = true;
          play(video);
        }
      });
      this.videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        resume();
      }, {threshold: 0});
      videos.forEach(video => {
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        const rect = video.getBoundingClientRect();
        if (rect.width && rect.height && rect.bottom > 0 && rect.top < window.innerHeight) visible.add(video);
        const button = video.closest('.cocktail-teal-film').querySelector('[data-play]');
        if (button) {
          const sync = () => {
            button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
            button.querySelector('[data-play-icon]').textContent = video.paused ? '▶' : 'Ⅱ';
          };
          button.addEventListener('click', () => {
            if (video.paused) {
              delete video.dataset.userPaused;
              play(video, true);
            } else {
              video.dataset.userPaused = 'true';
              video.autoplay = false;
              video.pause();
            }
          }, {signal});
          video.addEventListener('playing', sync, {signal});
          video.addEventListener('pause', sync, {signal});
          sync();
        }
        video.addEventListener('loadeddata', () => play(video), {signal});
        video.addEventListener('canplay', () => play(video), {signal});
        this.videoObserver.observe(video);
      });
      document.addEventListener('visibilitychange', resume, {signal});
      window.addEventListener('pageshow', resume, {signal});
      this.addEventListener('pointerup', event => {
        if (event.isTrusted && !event.target.closest('[data-play]')) videos.forEach(video => play(video));
      }, {signal});
      resume();
    }
    disconnectedCallback() { this.querySelectorAll('video').forEach(video => video.pause()); this.querySelector('[data-audio]')?.pause(); this.abort?.abort(); this.videoObserver?.disconnect(); delete this.dataset.ready; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-diamond-academy"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orrling-diamond-academy')) {
 customElements.define('orrling-diamond-academy', class extends HTMLElement {
 connectedCallback() {
  if(this.dataset.ready)return; this.dataset.ready='true'; this.abort=new AbortController(); const signal=this.abort.signal;
  this.querySelectorAll('[data-gallery]').forEach(gallery=>{const track=gallery.querySelector('.oda-track'),prev=gallery.querySelector('[data-prev]'),next=gallery.querySelector('[data-next]'),counter=gallery.querySelector('[data-counter]'); if(!prev)return;
  const index=()=>Math.max(0,Math.min(track.children.length-1,Math.round(track.scrollLeft/track.clientWidth)));
  const update=()=>{const i=index();prev.disabled=i===0;next.disabled=i===track.children.length-1;counter.textContent=(i+1)+' / '+track.children.length;};
  const move=step=>track.scrollTo({left:Math.max(0,Math.min(track.children.length-1,index()+step))*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  prev.addEventListener('click',()=>move(-1),{signal});next.addEventListener('click',()=>move(1),{signal});track.addEventListener('scroll',update,{passive:true,signal});track.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},{signal});update();});
  this.videoObserver=new IntersectionObserver(entries=>entries.forEach(({target:v,isIntersecting})=>{if(isIntersecting){v.muted=true;v.play().catch(()=>{});}else v.pause();}),{threshold:.1});this.querySelectorAll('video').forEach(v=>this.videoObserver.observe(v));
 }
 disconnectedCallback(){this.abort?.abort();this.videoObserver?.disconnect();delete this.dataset.ready;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-engraving-order"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orrling-engraving-order')) {
  customElements.define('orrling-engraving-order', class extends HTMLElement {
    el(key) { return this.querySelector('[data-' + key + ']'); }
    surface(width, height) { return Object.assign(document.createElement('canvas'), { width, height }); }
    connectedCallback() {
      if (this.initialized) return;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.initialized = true;
      this.words = JSON.parse(this.el('editor-words').textContent);
      this.mode = 'draw'; this.strokes = []; this.revision = 0; this.uploadTicket = 0; this.photoTicket = 0;
      this.controls = Object.fromEntries(['x', 'y', 'size', 'rotation'].map(key => [key, this.el('placement-' + key)]));
      this.querySelectorAll('input[type=radio]').forEach(radio => radio.addEventListener('change', () => {
        const note = this.el('source-note');
        note.textContent = radio.value.startsWith('My own') ? note.dataset.ownNote : note.dataset.newNote;
      }));
      this.querySelectorAll('[data-art-mode]').forEach(button => button.addEventListener('click', () => {
        this.mode = button.dataset.artMode;
        this.touch(); this.updateMode(); this.processMotif();
      }));
      this.el('artwork').addEventListener('change', () => this.loadArtwork(this.el('artwork').files[0]));
      for (const key of ['art-threshold', 'art-invert']) this.el(key).addEventListener('input', () => { this.touch(); this.processMotif(); });
      this.el('jewellery-photo').addEventListener('change', () => this.loadPhoto(this.el('jewellery-photo').files[0]));
      this.el('photo-camera').addEventListener('change', () => {
        const file = this.el('photo-camera').files[0];
        if (!file) return;
        const transfer = new DataTransfer(); transfer.items.add(file);
        this.el('jewellery-photo').files = transfer.files;
        this.loadPhoto(file);
      });
      this.setupDrawing(); this.setupPlacement(); this.updateMode();
      this.form.addEventListener('submit', event => { event.preventDefault(); void this.submitDesign(); });
    }
    showError(message) { const error = this.el('error'); error.textContent = message; error.hidden = !message; }
    touch() {
      this.revision++;
      for (const key of ['motif-upload', 'placement-upload', 'placement-summary', 'placement-data', 'art-processing']) this.el(key).value = '';
      this.showError('');
    }
    updateMode() {
      this.querySelectorAll('[data-art-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.artMode === this.mode)));
      this.el('draw-panel').hidden = this.mode !== 'draw';
      this.el('upload-panel').hidden = this.mode !== 'upload';
      this.el('artwork').disabled = this.mode !== 'upload';
      this.el('art-source').value = this.mode === 'draw' ? 'Drawn on page' : 'Uploaded artwork';
    }
    point(event, canvas) {
      const bounds = canvas.getBoundingClientRect();
      const clamp = value => Math.max(0, Math.min(1, value));
      return { x: clamp((event.clientX - bounds.left) / bounds.width), y: clamp((event.clientY - bounds.top) / bounds.height) };
    }
    setupDrawing() {
      const canvas = this.el('drawing-canvas');
      canvas.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' && event.button !== 0 || this.drawPointer != null) return;
        event.preventDefault(); canvas.setPointerCapture(event.pointerId);
        this.drawPointer = event.pointerId;
        this.stroke = { width: Number(this.el('pen').value), points: [this.point(event, canvas)] };
        this.strokes.push(this.stroke); this.touch(); this.drawStrokes();
      });
      canvas.addEventListener('pointermove', event => {
        if (event.pointerId !== this.drawPointer || !this.stroke) return;
        for (const point of event.getCoalescedEvents?.() || [event]) this.stroke.points.push(this.point(point, canvas));
        this.drawStrokes();
      });
      const finish = event => {
        if (event.pointerId !== this.drawPointer) return;
        this.drawPointer = null; this.stroke = null; this.processMotif();
      };
      for (const event of ['pointerup', 'pointercancel', 'lostpointercapture']) canvas.addEventListener(event, finish);
      this.el('drawing-undo').addEventListener('click', () => { this.drawPointer = null; this.stroke = null; this.strokes.pop(); this.touch(); this.drawStrokes(); this.processMotif(); });
      this.el('drawing-clear').addEventListener('click', () => { this.drawPointer = null; this.stroke = null; this.strokes = []; this.touch(); this.drawStrokes(); this.processMotif(); });
      this.drawStrokes();
    }
    drawStrokes() {
      const canvas = this.el('drawing-canvas'), context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.strokeStyle = '#000'; context.fillStyle = '#000'; context.lineCap = 'round'; context.lineJoin = 'round';
      for (const stroke of this.strokes) {
        context.lineWidth = stroke.width; context.beginPath();
        stroke.points.forEach((point, index) => { if (index) context.lineTo(point.x * canvas.width, point.y * canvas.height); else context.moveTo(point.x * canvas.width, point.y * canvas.height); });
        context.stroke();
        if (stroke.points.length === 1) { context.beginPath(); context.arc(stroke.points[0].x * canvas.width, stroke.points[0].y * canvas.height, stroke.width / 2, 0, Math.PI * 2); context.fill(); }
      }
      this.el('drawing-undo').disabled = !this.strokes.length;
      this.el('drawing-clear').disabled = !this.strokes.length;
    }
    validFile(file) { return !file || (['image/jpeg', 'image/png', 'image/webp'].includes(file.type) && file.size <= 10 * 1024 * 1024); }
    readImage(file, type, ticket) {
      const url = URL.createObjectURL(file), image = new Image();
      return new Promise(resolve => {
        image.onload = () => {
          URL.revokeObjectURL(url);
          if (ticket !== this[type + 'Ticket']) { resolve(null); return; }
          if (!image.naturalWidth || image.naturalWidth * image.naturalHeight > 40000000) { this.showError(this.words.file_error); resolve(null); return; }
          resolve(image);
        };
        image.onerror = () => { URL.revokeObjectURL(url); if (ticket === this[type + 'Ticket']) this.showError(type === 'photo' ? this.words.photo_error : this.words.file_error); resolve(null); };
        image.src = url;
      });
    }
    loadArtwork(file) {
      const ticket = ++this.uploadTicket;
      this.touch(); this.artworkImage = null; this.output = null; this.artReady = null;
      this.processMotif();
      if (!this.validFile(file)) { this.showError(this.words.file_error); return; }
      if (!file) return;
      this.el('art-status').textContent = this.words.processing;
      this.artReady = this.readImage(file, 'upload', ticket).then(image => {
        if (ticket !== this.uploadTicket) return;
        this.artworkImage = image; this.processMotif();
      });
    }
    loadPhoto(file) {
      const ticket = ++this.photoTicket;
      this.touch(); this.jewelleryImage = null; this.photoReady = null;
      this.el('placement-editor').hidden = true;
      if (!this.validFile(file)) { this.showError(this.words.file_error); return; }
      if (!file) return;
      this.photoReady = this.readImage(file, 'photo', ticket).then(image => {
        if (ticket !== this.photoTicket || !image) return;
        this.jewelleryImage = image;
        const scale = Math.min(1, 1200 / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = this.el('placement-canvas');
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale)); canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        this.el('placement-editor').hidden = false; this.drawPlacement();
      });
    }
    cleanPixels(rgba, width, height, threshold, invert = false) {
      const data = new Uint8ClampedArray(rgba.length);
      let count = 0, left = width, top = height, right = -1, bottom = -1;
      for (let index = 0; index < width * height; index++) {
        const at = index * 4, opacity = rgba[at + 3] / 255;
        const luma = .2126 * rgba[at] + .7152 * rgba[at + 1] + .0722 * rgba[at + 2];
        const value = (invert ? 255 - luma : luma) * opacity + 255 * (1 - opacity);
        const alpha = Math.round(255 * Math.max(0, Math.min(1, (threshold - value) / 16)));
        data[at + 3] = alpha;
        if (alpha > 16) { count++; const x = index % width, y = Math.floor(index / width); left = Math.min(left, x); top = Math.min(top, y); right = Math.max(right, x); bottom = Math.max(bottom, y); }
      }
      return { data, count, coverage: count / (width * height), bounds: count ? [left, top, right + 1, bottom + 1] : null };
    }
    processMotif() {
      this.output = null;
      const preview = this.el('motif-preview'), previewContext = preview.getContext('2d');
      previewContext.clearRect(0, 0, preview.width, preview.height);
      const source = this.mode === 'draw' ? (this.strokes.length ? this.el('drawing-canvas') : null) : this.artworkImage;
      if (!source) { this.el('art-status').textContent = this.words.empty; this.drawPlacement(); return; }
      const width = source.naturalWidth || source.width, height = source.naturalHeight || source.height;
      const scale = Math.min(1, 2000 / Math.max(width, height));
      const canvas = this.surface(Math.max(1, Math.round(width * scale)), Math.max(1, Math.round(height * scale)));
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(source, 0, 0, canvas.width, canvas.height);
      const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
      const threshold = this.mode === 'draw' ? 245 : Number(this.el('art-threshold').value);
      const result = this.cleanPixels(pixels.data, canvas.width, canvas.height, threshold, this.mode === 'upload' && this.el('art-invert').checked);
      if (!result.bounds || result.count < 4 || (this.mode === 'upload' && result.coverage > .85)) {
        this.el('art-status').textContent = this.words.invalid; this.drawPlacement(); return;
      }
      pixels.data.set(result.data); context.putImageData(pixels, 0, 0);
      const [left, top, right, bottom] = result.bounds, padding = 12;
      this.output = this.surface(right - left + padding * 2, bottom - top + padding * 2);
      this.output.getContext('2d').drawImage(canvas, left, top, right - left, bottom - top, padding, padding, right - left, bottom - top);
      const fit = Math.min(preview.width / this.output.width, preview.height / this.output.height);
      previewContext.drawImage(this.output, (preview.width - this.output.width * fit) / 2, (preview.height - this.output.height * fit) / 2, this.output.width * fit, this.output.height * fit);
      this.el('art-status').textContent = this.words.ready;
      this.drawPlacement();
    }
    setupPlacement() {
      const canvas = this.el('placement-canvas');
      const update = event => {
        const position = this.point(event, canvas);
        this.controls.x.value = Math.round(position.x * 100); this.controls.y.value = Math.round(position.y * 100);
        this.touch(); this.drawPlacement();
      };
      canvas.addEventListener('pointerdown', event => { if (event.pointerType === 'mouse' && event.button !== 0) return; event.preventDefault(); canvas.setPointerCapture(event.pointerId); this.placementPointer = event.pointerId; update(event); });
      canvas.addEventListener('pointermove', event => { if (event.pointerId === this.placementPointer) update(event); });
      const finish = () => { this.placementPointer = null; };
      for (const event of ['pointerup', 'pointercancel', 'lostpointercapture']) canvas.addEventListener(event, finish);
      canvas.addEventListener('keydown', event => {
        const move = { ArrowLeft: ['x', -1], ArrowRight: ['x', 1], ArrowUp: ['y', -1], ArrowDown: ['y', 1] }[event.key];
        if (!move) return;
        event.preventDefault(); this.controls[move[0]].value = Math.max(0, Math.min(100, Number(this.controls[move[0]].value) + move[1]));
        this.touch(); this.drawPlacement();
      });
      Object.values(this.controls).forEach(control => control.addEventListener('input', () => { this.touch(); this.drawPlacement(); }));
      this.el('placement-reset').addEventListener('click', () => { this.controls.x.value = 50; this.controls.y.value = 50; this.controls.size.value = 30; this.controls.rotation.value = 0; this.touch(); this.drawPlacement(); });
    }
    drawPlacement() {
      if (!this.jewelleryImage) return;
      const canvas = this.el('placement-canvas'), context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height); context.drawImage(this.jewelleryImage, 0, 0, canvas.width, canvas.height);
      if (!this.output) return;
      const width = Number(this.controls.size.value) / 100 * canvas.width, height = width * this.output.height / this.output.width;
      context.save(); context.translate(Number(this.controls.x.value) / 100 * canvas.width, Number(this.controls.y.value) / 100 * canvas.height);
      context.rotate(Number(this.controls.rotation.value) * Math.PI / 180); context.drawImage(this.output, -width / 2, -height / 2, width, height); context.restore();
    }
    exportFile(canvas, name) {
      return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(new File([blob], name, { type: 'image/png' })) : reject(new Error(this.words.sketch_error)), 'image/png'));
    }
    setFile(key, file) { const transfer = new DataTransfer(); transfer.items.add(file); this.el(key).files = transfer.files; }
    async submitDesign() {
      if (this.busy) return;
      this.busy = true; const button = this.form.querySelector('button[type=submit]'); button.disabled = true;
      const revision = this.revision;
      try {
        this.showError('');
        if (this.mode === 'upload' && this.artReady) await this.artReady;
        if (this.photoReady) await this.photoReady;
        if (this.revision !== revision || this.drawPointer != null) throw new Error(this.words.changed);
        if (this.mode === 'upload' && !this.validFile(this.el('artwork').files[0]) || !this.validFile(this.el('jewellery-photo').files[0])) throw new Error(this.words.file_error);
        this.processMotif();
        if (!this.output) throw new Error(this.words.invalid);
        const photo = this.el('jewellery-photo').files[0];
        if (photo && !this.jewelleryImage) throw new Error(this.words.photo_error);
        const motif = await this.exportFile(this.output, 'engraving-artwork.png');
        let sketch = null;
        if (photo) { this.drawPlacement(); sketch = await this.exportFile(this.el('placement-canvas'), 'engraving-placement.png'); }
        if (this.revision !== revision) throw new Error(this.words.changed);
        this.setFile('motif-upload', motif);
        this.el('art-processing').value = JSON.stringify({ version: 2, source: this.mode, threshold: this.mode === 'draw' ? 245 : Number(this.el('art-threshold').value), inverted: this.mode === 'upload' && this.el('art-invert').checked, width: this.output.width, height: this.output.height, format: 'transparent black PNG' });
        if (sketch) {
          this.setFile('placement-upload', sketch);
          const position = { version: 2, source: this.mode, anchor: 'centre', x_percent: Number(this.controls.x.value), y_percent: Number(this.controls.y.value), width_percent: Number(this.controls.size.value), rotation_degrees: Number(this.controls.rotation.value), photo_width: this.jewelleryImage.naturalWidth, photo_height: this.jewelleryImage.naturalHeight };
          this.el('placement-data').value = JSON.stringify(position);
          this.el('placement-summary').value = 'Motif: centre ' + position.x_percent + '% from left, ' + position.y_percent + '% from top; width ' + position.width_percent + '% of photo; rotation ' + position.rotation_degrees + '°';
        } else { this.el('placement-upload').value = ''; this.el('placement-summary').value = ''; this.el('placement-data').value = ''; }
        HTMLFormElement.prototype.submit.call(this.form);
      } catch (failure) { this.showError(failure.message || this.words.sketch_error); button.disabled = false; this.busy = false; }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-jewellery-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jewellery-stories')) {
  customElements.define('jewellery-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-gallery]').forEach(gallery => {
        const track = gallery.querySelector('[data-track]');
        const slides = [...track.children];
        const prev = gallery.querySelector('[data-prev]');
        const next = gallery.querySelector('[data-next]');
        const counter = gallery.querySelector('[data-index]');
        const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        const update = () => { const i = index(); counter.textContent = i + 1; prev.disabled = i === 0; next.disabled = i === slides.length - 1; };
        const move = step => { const i = Math.max(0, Math.min(slides.length - 1, index() + step)); track.scrollTo({left: i * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'}); };
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', update, {passive:true, signal});
        track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } }, {signal});
        update();
      });
      this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting && !reduced.matches && !video.dataset.userPaused) video.play().catch(() => {});
        else video.pause();
      }), {threshold:.2});
      this.querySelectorAll('.pearl-film').forEach(film => {
        const video = film.querySelector('video');
        const button = film.querySelector('[data-play]');
        if (!video || !button) return;
        const sync = () => { button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel); button.querySelector('[data-play-icon]').textContent = video.paused ? '▶' : 'Ⅱ'; };
        button.addEventListener('click', () => { if (video.paused) { delete video.dataset.userPaused; video.play().catch(() => {}); } else { video.dataset.userPaused = 'true'; video.pause(); } }, {signal});
        video.addEventListener('play', sync, {signal}); video.addEventListener('pause', sync, {signal});
        this.videoObserver.observe(video); sync();
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.videoObserver?.disconnect(); delete this.dataset.ready; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-pearl-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pearl-stories')) {
  customElements.define('pearl-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-gallery]').forEach(gallery => {
        const track = gallery.querySelector('[data-track]');
        const slides = [...track.children];
        const prev = gallery.querySelector('[data-prev]');
        const next = gallery.querySelector('[data-next]');
        const counter = gallery.querySelector('[data-index]');
        const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        const update = () => { const i = index(); counter.textContent = i + 1; prev.disabled = i === 0; next.disabled = i === slides.length - 1; };
        const move = step => { const i = Math.max(0, Math.min(slides.length - 1, index() + step)); track.scrollTo({left: i * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'}); };
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', update, {passive:true, signal});
        track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } }, {signal});
        update();
      });
      const videos = [...this.querySelectorAll('.pearl-film video')];
      const visible = new Set();
      const pending = new Set();
      const play = (video, manual = false) => {
        if (!video.paused || pending.has(video) || document.hidden) return;
        if (!manual && (video.dataset.userPaused || !visible.has(video))) return;
        video.muted = true;
        pending.add(video);
        video.play().catch(() => {}).finally(() => pending.delete(video));
      };
      const resume = () => videos.forEach(video => {
        if (document.hidden || !visible.has(video) || video.dataset.userPaused) {
          video.autoplay = false;
          video.pause();
        } else {
          video.autoplay = true;
          play(video);
        }
      });
      this.videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        resume();
      }, {threshold: 0});
      videos.forEach(video => {
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        const rect = video.getBoundingClientRect();
        if (rect.width && rect.height && rect.bottom > 0 && rect.top < window.innerHeight) visible.add(video);
        const button = video.closest('.pearl-film').querySelector('[data-play]');
        if (button) {
          const sync = () => {
            button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
            button.querySelector('[data-play-icon]').textContent = video.paused ? '▶' : 'Ⅱ';
          };
          button.addEventListener('click', () => {
            if (video.paused) {
              delete video.dataset.userPaused;
              play(video, true);
            } else {
              video.dataset.userPaused = 'true';
              video.autoplay = false;
              video.pause();
            }
          }, {signal});
          video.addEventListener('playing', sync, {signal});
          video.addEventListener('pause', sync, {signal});
          sync();
        }
        video.addEventListener('loadeddata', () => play(video), {signal});
        video.addEventListener('canplay', () => play(video), {signal});
        this.videoObserver.observe(video);
      });
      document.addEventListener('visibilitychange', resume, {signal});
      window.addEventListener('pageshow', resume, {signal});
      this.addEventListener('pointerup', event => {
        if (event.isTrusted && !event.target.closest('[data-play]')) videos.forEach(video => play(video));
      }, {signal});
      resume();
    }
    disconnectedCallback() { this.querySelectorAll('video').forEach(video => video.pause()); this.abort?.abort(); this.videoObserver?.disconnect(); delete this.dataset.ready; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-personalization"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('orrling-personalization')){
customElements.define('orrling-personalization',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.classList.add('enhanced');this.entries=[...this.querySelectorAll('.ep-entry')];this.dialog=this.querySelector('dialog');this.body=this.querySelector('.ep-dialog-body');this.active=0;this.photo=0;
this.addEventListener('click',e=>{const summary=e.target.closest('summary');if(summary&&this.contains(summary)){e.preventDefault();this.opener=summary;this.open(this.entries.indexOf(summary.parentElement));return;}if(e.target.closest('.ep-close'))this.dialog.close();const chapter=e.target.closest('[data-chapter]');if(chapter)this.open(this.active+Number(chapter.dataset.chapter));const photo=e.target.closest('[data-photo]');if(photo)this.setPhoto(this.photo+Number(photo.dataset.photo));if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
this.dialog.addEventListener('close',()=>{this.pause();this.querySelectorAll('.is-active').forEach(e=>e.classList.remove('is-active'));this.opener?.focus();});
this.addEventListener('shopify:block:select',e=>{const entry=e.target.querySelector('.ep-entry');if(entry)this.open(this.entries.indexOf(entry));});}
pause(){this.body.querySelectorAll('video').forEach(v=>v.pause());}
open(index){if(index<0||index>=this.entries.length)return;this.pause();this.active=index;this.body.replaceChildren(this.entries[index].querySelector('.ep-story').cloneNode(true));const heading=this.body.querySelector('h2');heading.id=this.id+'-active-title';this.dialog.setAttribute('aria-labelledby',heading.id);this.querySelectorAll('.ep-event').forEach((e,i)=>e.classList.toggle('is-active',i===index));this.dialog.querySelector('[data-chapter="-1"]').disabled=index===0;this.dialog.querySelector('[data-chapter="1"]').disabled=index===this.entries.length-1;this.setPhoto(0);if(!this.dialog.open)this.dialog.showModal();this.dialog.scrollTop=0;}
setPhoto(index){this.pause();const slides=[...this.body.querySelectorAll('.ep-slide')];if(!slides.length)return;this.photo=(index+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==this.photo);this.body.querySelector('.ep-gallery-nav').hidden=slides.length<2;this.body.querySelector('.ep-count').textContent=(this.photo+1)+' / '+slides.length;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-press"] && !Shopify.designMode) return;
  try {
    


if(!customElements.get('orrling-press')){
customElements.define('orrling-press',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.classList.add('enhanced');this.entries=[...this.querySelectorAll('.op-entry')];this.dialog=this.querySelector('dialog');this.body=this.querySelector('.op-dialog-body');this.active=0;this.photo=0;this.dialog.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();this.setPhoto(this.photo-1);}if(e.key==='ArrowRight'){e.preventDefault();this.setPhoto(this.photo+1);}});
this.addEventListener('click',e=>{const filter=e.target.closest('[data-filter]');if(filter){const category=filter.dataset.filter;this.toggleAttribute('data-filtered',Boolean(category));this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));this.entries.forEach(entry=>{entry.closest('.op-event').hidden=Boolean(category)&&entry.querySelector('.op-year').textContent.trim()!==category;});return;}const summary=e.target.closest('summary');if(summary&&this.contains(summary)){e.preventDefault();this.opener=summary;this.open(this.entries.indexOf(summary.parentElement));return;}if(e.target.closest('.op-close'))this.dialog.close();const chapter=e.target.closest('[data-chapter]');if(chapter)this.open(this.active+Number(chapter.dataset.chapter));const photo=e.target.closest('[data-photo]');if(photo)this.setPhoto(this.photo+Number(photo.dataset.photo));if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
this.dialog.addEventListener('close',()=>{this.pause();this.querySelectorAll('.is-active').forEach(e=>e.classList.remove('is-active'));this.opener?.focus();});
this.addEventListener('shopify:block:select',e=>{const entry=e.target.querySelector('.op-entry');if(entry)this.open(this.entries.indexOf(entry));});}
pause(){this.body.querySelectorAll('video').forEach(v=>v.pause());}
open(index){if(index<0||index>=this.entries.length)return;this.pause();this.active=index;this.body.replaceChildren(this.entries[index].querySelector('.op-story').cloneNode(true));const heading=this.body.querySelector('h2');heading.id=this.id+'-active-title';this.dialog.setAttribute('aria-labelledby',heading.id);this.querySelectorAll('.op-event').forEach((e,i)=>e.classList.toggle('is-active',i===index));this.dialog.querySelector('[data-chapter="-1"]').disabled=index===0;this.dialog.querySelector('[data-chapter="1"]').disabled=index===this.entries.length-1;this.setPhoto(0);if(!this.dialog.open)this.dialog.showModal();this.dialog.scrollTop=0;}
setPhoto(index){this.pause();const slides=[...this.body.querySelectorAll('.op-slide')];if(!slides.length)return;this.photo=(index+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==this.photo);this.body.querySelector('.op-gallery-nav').hidden=slides.length<2;this.body.querySelector('.op-count').textContent=(this.photo+1)+' / '+slides.length;slides[this.photo].querySelectorAll('video').forEach(v=>{v.muted=true;v.loop=true;v.controls=false;v.setAttribute('playsinline','');v.play().catch(()=>{});});}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-retailer-images"]) return;
  try {
    
document.addEventListener('click', async event => {
  const link = event.target.closest('[data-ori-download]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  if (link.getAttribute('aria-busy') === 'true') return;
  const root = link.closest('[data-ori]');
  const status = root.querySelector('[data-ori-status]');
  link.setAttribute('aria-busy', 'true');
  status.textContent = root.dataset.loading;
  try {
    const response = await fetch(link.href, { credentials: 'omit' });
    if (!response.ok) throw new Error('Download failed');
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const save = document.createElement('a');
    save.href = url;
    save.download = decodeURIComponent(new URL(link.href).pathname.split('/').pop());
    document.body.append(save);
    save.click();
    save.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    status.textContent = '';
  } catch {
    status.textContent = root.dataset.error;
  } finally {
    link.removeAttribute('aria-busy');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-retailer-studio"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('[data-copy-url]').forEach(button=>button.addEventListener('click',async()=>{const status=button.parentElement.querySelector('[data-copy-status]');try{const url=new URL(button.dataset.copyUrl,location.origin);await navigator.clipboard.writeText(url.href);status.textContent=url.href;}catch{status.textContent=new URL(button.dataset.copyUrl,location.origin).href;}}));

document.querySelectorAll('.ors-assortment').forEach(area=>{
 const collection=area.querySelector('[data-ors-collection]'),category=area.querySelector('[data-ors-category]');
 const filter=()=>{let visible=0;area.querySelectorAll('[data-ors-memberships]').forEach(card=>{const memberships=card.dataset.orsMemberships;card.hidden=!!((collection.value&&!memberships.includes('|'+collection.value+'|'))||(category.value&&!memberships.includes('|'+category.value+'|')));if(!card.hidden)visible++});area.querySelector('[data-ors-empty]').hidden=visible>0};
 collection.addEventListener('change',filter);category.addEventListener('change',filter);
});


document.addEventListener('click',event=>{
 document.querySelectorAll('.ors-lookbook-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
});
document.addEventListener('keydown',event=>{
 if(event.key!=='Escape')return;
 document.querySelectorAll('.ors-lookbook-menu[open]').forEach(menu=>{const focused=menu.contains(document.activeElement);menu.open=false;if(focused)menu.querySelector('summary').focus();});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-studio-chapters"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orrling-studio-stories')) {
customElements.define('orrling-studio-stories', class extends HTMLElement {
 connectedCallback() {
  this.galleryAbort?.abort();
  this.galleryAbort = new AbortController();
  const signal = this.galleryAbort.signal;
  this.querySelectorAll('.studio-gallery').forEach(gallery => {
   const track = gallery.querySelector('.studio-gallery-track');
   const count = gallery.querySelector('.studio-gallery-count');
   const index = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
   const go = step => {
    const next = (index() + step + track.children.length) % track.children.length;
    track.scrollTo({left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   };
   gallery.querySelectorAll('[data-studio-step]').forEach(button => button.addEventListener('click', () => go(Number(button.dataset.studioStep)), {signal}));
   track.addEventListener('scroll', () => { count.textContent = (index() + 1) + ' / ' + track.children.length; }, {signal, passive: true});
   track.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    go(event.key === 'ArrowRight' ? 1 : -1);
   }, {signal});
  });
  this.observer?.disconnect();
  this.observer = new IntersectionObserver(entries => entries.forEach(({target: video, isIntersecting}) => {
   if (isIntersecting) { video.muted = true; video.play().catch(() => {}); }
   else video.pause();
  }), {threshold: .05});
  this.querySelectorAll('video').forEach(video => this.observer.observe(video));
 }
 disconnectedCallback() { this.observer?.disconnect(); this.galleryAbort?.abort(); }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orrling-timeline"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('orrling-timeline')){
customElements.define('orrling-timeline',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.classList.add('enhanced');this.entries=[...this.querySelectorAll('.ot-entry')];this.dialog=this.querySelector('dialog');this.body=this.querySelector('.ot-dialog-body');this.active=0;this.photo=0;
this.addEventListener('click',e=>{const summary=e.target.closest('summary');if(summary&&this.contains(summary)){e.preventDefault();this.opener=summary;this.open(this.entries.indexOf(summary.parentElement));return;}if(e.target.closest('.ot-close'))this.dialog.close();const chapter=e.target.closest('[data-chapter]');if(chapter)this.open(this.active+Number(chapter.dataset.chapter));const photo=e.target.closest('[data-photo]');if(photo)this.setPhoto(this.photo+Number(photo.dataset.photo));if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
this.dialog.addEventListener('close',()=>{this.pause();this.querySelectorAll('.is-active').forEach(e=>e.classList.remove('is-active'));this.opener?.focus();});
this.addEventListener('shopify:block:select',e=>{const entry=e.target.querySelector('.ot-entry');if(entry)this.open(this.entries.indexOf(entry));});}
pause(){this.body.querySelectorAll('video').forEach(v=>v.pause());}
open(index){if(index<0||index>=this.entries.length)return;this.pause();this.active=index;this.body.replaceChildren(this.entries[index].querySelector('.ot-story').cloneNode(true));const heading=this.body.querySelector('h2');heading.id=this.id+'-active-title';this.dialog.setAttribute('aria-labelledby',heading.id);this.querySelectorAll('.ot-event').forEach((e,i)=>e.classList.toggle('is-active',i===index));this.dialog.querySelector('[data-chapter="-1"]').disabled=index===0;this.dialog.querySelector('[data-chapter="1"]').disabled=index===this.entries.length-1;this.setPhoto(0);if(!this.dialog.open)this.dialog.showModal();this.dialog.scrollTop=0;}
setPhoto(index){this.pause();const slides=[...this.body.querySelectorAll('.ot-slide')];if(!slides.length)return;this.photo=(index+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==this.photo);this.body.querySelector('.ot-gallery-nav').hidden=slides.length<2;this.body.querySelector('.ot-count').textContent=(this.photo+1)+' / '+slides.length;}
});}

  } catch(e) { console.error(e); }
})();
})();
